'use strict';
// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('AgrothingsIntegrationService', function($http) {
  const baseUrl = `${SERVER}/${API_VERSION}/agrothings_integration/`;

  return {
    listMachinary: function() {
      const url = `${baseUrl}machinary`;
      return $http.get(url);
    }
  };
});
